import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import $ from "jquery";
import moment from "moment";
import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import { DebounceInput } from "react-debounce-input";
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import Toggle from "react-toggle";
import LocationSelect from "../../src/integration/LocationSelect";
import "../calendar/calendareventdatepickers.scss";
import ActionButton from "../common/button/actionbutton.component.jsx";
import Checkbox from "../common/checkbox/checkbox.component.jsx";
import OnlinePayment from "../common/credit-card/online-payment.component.jsx";
import EventBus from "../common/EventBus.js";
import MoneyInputForm from "../common/form/moneyinput.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import StandardList from "../common/listing/list.component.jsx";
import CheckboxWrapper from '../common/rich-text/feature-protection-wrappers/checkboxWrapper.component';
import TerminalPayment from "../common/terminal-payment/TerminalPayment";
import TestPaymentMethodBadge from "../customer/TestPaymentMethodBadge";
import PaymentAccountService from "../payment-account/service/paymentAccountService";
import TestModeAlert from "../payment-processing/components/TestModeAlert";
import PaymentTypeSelect from "../payment-type/paymenttypeselect.jsx";
import BankAccountLabel from "../payment/bankaccount.component.jsx";
import CreditCardLabel from "../payment/creditcard.component.jsx";
import { PAYMENT_METHOD, PAYMENT_SOURCE, PAYMENT_TYPE } from "../state/helpers/Payment";
import { INTEGRATIONS_TERMINAL_PAYMENT_SUPPORT, INTEGRATION_KEY } from "../state/integration/Constants";
import Location from "../state/location/Location";
import { PROPOSAL_TYPE } from "../state/proposal/ProposalType";
import TerminalService from "../state/terminal/TerminalService";
import { CURRENCY } from "../utils/currency/constants";
import DepositCreditMemoSelect from "./depositcreditmemoselect.component.jsx";

const uuidv4 = require('uuid/v4')

const messages = defineMessages({
    "note_placeholder": {
        id: 'invoice.receive_payment.note_placeholder',
        defaultMessage: 'Payment notes',
    },
    "quotes_deposit_label": {
        id: 'invoice.receive_payment.quote_deposit_label',
        defaultMessage: 'Deposits from quotes',
    },
    "orders_deposit_label": {
        id: 'invoice.receive_payment.order_deposit_label',
        defaultMessage: 'Deposits from orders',
    },
})

class ReceivePaymentModal extends Component {

    constructor(props, context) {
        super(props, context)
        let paymentType = this.props.paymentType
        let hasCreditMemoReference = false
        if (paymentType === 'quote-deposit') {
            paymentType = this.getDepositPaymentType(this.props.invoice)
            hasCreditMemoReference = true
        }
        const hasIntegratedPayment = AppContext.hasFeatureIntegration(Features.IntegratedPayment)
        let defaultAmount = this.props.defaultAmount || '0'
        this.state = {
            invoice: this.props.invoice || null,
            //can be a quote or order
            depositPayableObject: this.props.depositPayableObject || null,
            project: this.props.project || null,
            customerAccount: this.props.customerAccount || null,
            customerAccountId: this.props.customerAccountId || null,
            customerName: this.props.customerName || '',
            contactType: '',
            className: this.props.className || '',
            amount: parseFloat(defaultAmount) ? defaultAmount : this.getAmount(this.props.invoice, this.props.depositPayableObject),
            note: '',
            creditCardError: '',
            paymentType: paymentType || 'credit-card',
            contactId: this.getContactId(this.props.customerAccount, this.props.invoice, this.props.project),
            cardsOnFile: [],
            bankAccountsOnFile: [],
            dueInvoices: [],
            dueInvoicesPerLocation: {},
            selectedDueInvoices: [],
            location: {},
            locations: [],
            loadingLocations: true,
            savedCardToken: '',
            savedBankAccountToken: '',
            savedCardPaymentFlow: '',
            invoicePayments: [],
            activeCurrency: this.getCurrency(this.props.invoice || this.props.depositPayableObject),
            creditCurrency: '',
            creditBalance: 0,
            creditBalanceFromDeposit: 0,
            percent: '',
            totalAmount: this.getFullAmount(this.props.invoice || this.props.depositPayableObject),
            modalId: this.props.modalId || 'receive-payment-modal-' + uuidv4(),
            hasIntegratedPayment: hasIntegratedPayment,
            enableIntegratedPayment: hasIntegratedPayment,
            hasIntegratedPaymentBankTransfer: AppContext.hasFeatureIntegration(Features.IntegratedPaymentBankTransfer) && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureIntegratedBankTransfer),
            enableIntegratedPaymentBankTransfer: AppContext.hasFeatureIntegration(Features.IntegratedPaymentBankTransfer),
            paymentIntegrationKey: AppContext.getPaymentIntegrationKey(),
            paymentIntegration: AppContext.getIntegrationByFeature('integrated-payment'),
            customPaymentTypeId: '',
            creditMemoId: '',
            creditMemoAmount: 0,
            accountLimit: null,
            isLoading: false,
            depositTransactions: this.getDepositTransactions(this.props.depositPayableObject),
            disableSubmitButtonOnSuccess: false,
            hasCreditMemoReference: hasCreditMemoReference,
            capturedAt: moment().toDate(),
            locale: AppContext.getLocale().getLanguage(),
            paymentAccounts: [],
            terminals: [],
            isFormDisabled: false,
            currentPaymentAccount: null,
        }

        this.closeModal = this.closeModal.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.applyPayment = this.applyPayment.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleSubmitNewCard = this.handleSubmitNewCard.bind(this)
        this.handleSubmitExistingCard = this.handleSubmitExistingCard.bind(this)
        this.handleSubmitExistingBankAccount = this.handleSubmitExistingBankAccount.bind(this)
        this.checkAllInvoices = this.checkAllInvoices.bind(this)
        this.changePercent = this.changePercent.bind(this)
        this.handlePaymentIntentCompleted = this.handlePaymentIntentCompleted.bind(this)
        this.buildMetaData = this.buildMetaData.bind(this)
        this.buildTransactionsAndCurrency = this.buildTransactionsAndCurrency.bind(this)
        this.buildIdenitifierList = this.buildIdenitifierList.bind(this)
        this.buildDocumentIds = this.buildDocumentIds.bind(this)
        this.buildAmountsList = this.buildAmountsList.bind(this)
        this.buildLocationId = this.buildLocationId.bind(this)
        this.onLocationSelect = this.onLocationSelect.bind(this)
        this.getCardsOnFileByIntegrationKey = this.getCardsOnFileByIntegrationKey.bind(this)
        this.getBankAccountsOnFileByIntegrationKey = this.getBankAccountsOnFileByIntegrationKey.bind(this)
        this.showTabAndContent = this.showTabAndContent.bind(this)
        this.getPaymentIntegrationId = this.getPaymentIntegrationId.bind(this)
        this.setTokens = this.setTokens.bind(this)
        this.retrieveMethodsOnFile = this.retrieveMethodsOnFile.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            customerAccountId: nextProps.customerAccountId || null,
            invoice: nextProps.invoice || null,
            project: nextProps.project || null,
            amount: this.getAmount(nextProps.invoice, nextProps.depositPayableObject),
            totalAmount: this.getFullAmount(nextProps.invoice || nextProps.depositPayableObject),
            activeCurrency: this.getCurrency(nextProps.invoice || nextProps.depositPayableObject),
            depositPayableObject: nextProps.depositPayableObject || null,
        })
    }

    getDepositPaymentType(invoice) {
        if (invoice) {
            if (invoice.attributes.quoteReferenceId) {
                return 'quote-deposit'
            }
            if (invoice.attributes.orderReferenceId) {
                return 'order-deposit'
            }
        }
        return ''
    }

    getDepositTransactions(object) {
        return (object && object.attributes && object.attributes.paymentTransactions) ?
            object.attributes.paymentTransactions.filter(trans => trans.attributes.creditMemoId) : []
    }

    getAmount(invoice, depositPayableObject) {
        if (invoice) {
            return invoice.attributes.balance
        }
        if (depositPayableObject && depositPayableObject.type === 'orders') {
            return depositPayableObject.attributes.balance
        }
        if (depositPayableObject) {
            return depositPayableObject.attributes.depositBalance
        }
        return ''
    }

    getFullAmount(payableObject) {
        if (payableObject && payableObject.attributes) {
            return payableObject.attributes.totalAmount
        }
        return ''
    }

    getCurrency(payableObject) {
        if (payableObject && payableObject.attributes) {
            return payableObject.attributes.currency
        }
        return ''
    }

    getContactId(customerAccount, invoice, project) {
        if (customerAccount) {
            return customerAccount.id
        }
        if (invoice) {
            return invoice.attributes.contactId
        }
        if (project) {
            return project.attributes.contactId
        }
        return ''
    }

    getIdentifier(payableObject) {
        if (payableObject) {
            return payableObject.attributes.identifier
        }
        return ''
    }

    retrieveMethodsOnFile() {
        AppContext.getApiClient().get('/contacts/' + this.state.contactId).then(res => {
            GlobalHelper.captureFingerprint(location.href, res.attributes.accountId);
            return this.getAvailablePaymentMethods(res.attributes.cardsOnFile).then(cardsOnFile => {
                this.setState({
                    cardsOnFile: cardsOnFile,
                })
            }).then(() => {
                return this.getAvailablePaymentMethods(res.attributes.bankAccountsOnFile)
            }).then(bankAccountsOnFile => {
                this.setState({
                    bankAccountsOnFile: bankAccountsOnFile,
                })
                this.setState({
                    contactType: res.type,
                })
            }).then(() => {
                this.setTokens()
            })
        })
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        AppContext.getApiClient().get('/customer-accounts/' + this.state.contactId).then(res => {
            if (res.error) {
                return
            }
            this.setState({
                customerAccount: res,
                creditBalance: parseFloat(res.attributes.creditBalance),
                creditBalanceFromDeposit: parseFloat(res.attributes.creditBalanceFromDeposit),
                creditCurrency: res.attributes.creditBalanceCurrency,
            })
        })

        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            },
                () => {
                    if (this.state.customerAccountId) {
                        AppContext.getApiClient().get('/customer-accounts/' + this.state.contactId + '/due-invoices').then(res => {
                            if (res.error) {
                                return
                            }
                            const payments = res.data.map(inv => {
                                return {
                                    invoiceId: inv.id,
                                    identifier: inv.identifier,
                                    currency: inv.currency,
                                    checked: (GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) && inv.importedAt !== null) ? false : true,
                                    amount: parseFloat(inv.balance),
                                    balance: parseFloat(inv.balance),
                                    isBlocked: (GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) && inv.importedAt !== null) ? true : false
                                }
                            })
                            this.setState({
                                dueInvoices: res.data,
                                invoicePayments: payments,
                                amount: this.getTotalAmount(payments)
                            })

                        }).then(() => {
                            // Remove invoices with location disabled
                            this.setState({
                                dueInvoices: this.state.dueInvoices.filter(inv =>
                                    !inv.locationId || GlobalHelper.findLocationById(inv.locationId).attributes?.enabled
                                )
                            })
                            let invoiceLocationIds = [...new Set(this.state.dueInvoices.map(inv => inv.locationId))]

                            if (invoiceLocationIds.length > 0) {

                                const locations = AppContext.locations.filter(loc => invoiceLocationIds.includes(loc.id))
                                let location = null
                                let dueInvoicesPerLocation = { "": [] }
                                const invoicesWithoutLocation = this.state.dueInvoices.filter((invoice) => !invoice.locationId)
                                let initialSelectedInvoices = []

                                if (AppContext.locations.length === 0) {
                                    invoicesWithoutLocation.forEach((invoiceWithoutLocation) => {
                                        dueInvoicesPerLocation[""].push(invoiceWithoutLocation)
                                    })
                                    initialSelectedInvoices = dueInvoicesPerLocation[""]
                                } else if (locations.length === 0) {
                                    //allow to pay all invoices without location id if you only have one enabled all locations payment integration
                                    if (GlobalHelper.hasOnlyOneAllPaymentIntegrationOrNone()) {
                                        const invoicesWithoutLocation = this.state.dueInvoices.filter((invoice) => !invoice.locationId)
                                        const dueInvoicesPerLocation = { "": invoicesWithoutLocation }

                                        this.setState({
                                            location: {},
                                            dueInvoicesPerLocation: dueInvoicesPerLocation,
                                            selectedDueInvoices: dueInvoicesPerLocation[""],
                                            loadingLocations: false,
                                        }, () => {
                                            this.retrieveMethodsOnFile()
                                        })
                                    }

                                    return
                                } else {
                                    if (GlobalHelper.areAllEnabledLocationsAssignedToOneIntegration()) {
                                        initialSelectedInvoices = this.state.dueInvoices
                                        initialSelectedInvoices = initialSelectedInvoices.filter((inv) => {
                                            return GlobalHelper.isLocationAssignedToIntegrationId(inv.locationId, this.state.paymentIntegration.id)
                                        })
                                        location = AppContext.locations.find(loc => loc.attributes.enabled)
                                    } else {
                                        const userLocationId = AppContext.getUserLoggedIn().attributes?.locationId
                                        if (userLocationId) {
                                            location = locations.find(loc => loc.id === userLocationId)
                                        }
                                        if (!location) {
                                            location = locations[0]
                                        }
                                        const invoicesWithLocation = this.state.dueInvoices.filter((invoice) => invoice.locationId)

                                        dueInvoicesPerLocation = invoicesWithLocation.reduce((map, invoice) => {
                                            const locationId = invoice.locationId
                                            map[locationId] = map[locationId] || []
                                            map[locationId].push(invoice)
                                            return map
                                        }, {})


                                        // Allows payment on invoices with no locations, while having locations
                                        invoiceLocationIds = invoiceLocationIds.filter(loc => loc != "")

                                        // Add invoices without locationId
                                        invoicesWithoutLocation.forEach((invoiceWithoutLocation) => {
                                            invoiceLocationIds.forEach((id) => {
                                                dueInvoicesPerLocation[id].push(invoiceWithoutLocation)
                                            })
                                        })
                                        initialSelectedInvoices = dueInvoicesPerLocation[location.id]
                                    }
                                }

                                const payments = initialSelectedInvoices.map(inv => {
                                    return {
                                        invoiceId: inv.id,
                                        identifier: inv.identifier,
                                        currency: inv.currency,
                                        checked: (GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) && inv.importedAt !== null) ? false : true,
                                        amount: parseFloat(inv.balance),
                                        balance: parseFloat(inv.balance),
                                        isBlocked: (GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) && inv.importedAt !== null) ? true : false
                                    }
                                })

                                this.setState({
                                    locations: locations,
                                    location: location ? {
                                        value: location.id,
                                        label: location.attributes.name
                                    } : {},
                                    dueInvoicesPerLocation: dueInvoicesPerLocation,
                                    selectedDueInvoices: initialSelectedInvoices,
                                    invoicePayments: payments,
                                    amount: this.getTotalAmount(payments),
                                    loadingLocations: false,
                                }, () => {
                                    this.retrieveMethodsOnFile()
                                })
                            }
                        })
                    } else {
                        this.retrieveMethodsOnFile()
                    }
                })
        })

        PaymentAccountService.getPaymentAccounts()
            .then(paymentAccounts => {
                this.setState({ paymentAccounts })
                if (paymentAccounts && paymentAccounts.length) {
                    const locationId = this.state.invoice?.attributes?.locationId || this.state.depositPayableObject?.attributes?.locationId
                    const pa = this.state.paymentAccounts.find(pa => (pa.getLocationIds().includes(locationId)))
                    this.setState({
                        currentPaymentAccount: pa ? pa : this.state.paymentAccounts.find(pa => (pa.getLocationIds().length == 0)),
                    })
                    if (this.state.currentPaymentAccount) {
                        TerminalService.listForPaymentAccount(this.state.currentPaymentAccount.getId())
                            .then(terminals => {
                                if (terminals && terminals.length) {
                                    this.setState({
                                        terminals: terminals
                                            .sort((a, b) => a.getName().localeCompare(b.getName()))
                                    })
                                }
                            })
                    }
                }
            });
    }

    getAvailablePaymentMethods(paymentMethodsOnFile) {
        let promises = []
        let paymentMethods = []
        let paymentMethodsFromDeletedIntegrations = []
        for (let paymentMethod of paymentMethodsOnFile) {
            let integrationFound = false
            for (let integration of AppContext.integrations) {
                if (paymentMethod.attributes.integrationConfigurationId === integration.id) {
                    paymentMethod.attributes.locationId = integration.attributes.locationId
                    paymentMethod.attributes.externalAccountId = integration.attributes.externalAccountId
                    paymentMethods.push(paymentMethod)
                    integrationFound = true
                    break
                }
            }

            if (!integrationFound) {
                paymentMethodsFromDeletedIntegrations.push(paymentMethod)
                promises.push(AppContext.getApiClient().get(`/integration-configurations/${paymentMethod.attributes.integrationConfigurationId}`))
            }
        }

        return Promise.all(promises).then(integrations => {
            let integrationLocationMap = {}
            let integrationExternalAccountIdMap = {}
            for (let integration of integrations) {
                if (!integration.error) {
                    integrationLocationMap[integration.id] = integration.attributes.locationId
                    integrationExternalAccountIdMap[integration.id] = integration.attributes.externalAccountId
                }
            }
            paymentMethodsFromDeletedIntegrations = paymentMethodsFromDeletedIntegrations.map(paymentMethod => {
                paymentMethod.attributes.locationId = integrationLocationMap[paymentMethod.attributes.integrationConfigurationId]
                paymentMethod.attributes.externalAccountId = integrationExternalAccountIdMap[paymentMethod.attributes.integrationConfigurationId]
                return paymentMethod
            })

            paymentMethodsOnFile = paymentMethods.concat(paymentMethodsFromDeletedIntegrations).filter(c => (!c.attributes.locationId ||
                (this.state.invoice ? c.attributes.locationId === this.state.invoice.attributes.locationId : true) ||
                (this.state.quote ? c.attributes.locationId === this.state.quote.attributes.locationId : true) ||
                c.attributes.externalAccountId === this.state.paymentIntegration?.attributes.externalAccountId))

            return paymentMethodsOnFile
        })
    }

    setInvoiceAmount(invoiceId, amount) {
        let amounts = this.state.invoicePayments.map(pay => {
            if (pay.invoiceId === invoiceId) {
                pay.amount = parseFloat(amount || 0)
            }
            return pay
        })
        const totalAmount = this.getTotalAmount(amounts)

        this.setState({
            invoicePayments: amounts,
            amount: totalAmount,
        })
        this.state.invoicePayments = amounts
        this.state.amount = totalAmount
    }

    getTotalAmount(payments) {
        const amount = payments.filter(pay => pay.checked).reduce(function (accumulator, pay) {
            return accumulator + pay.amount;
        }, 0)
        if (amount) {
            return parseFloat(amount).toFixed(2).toString()
        }
        return 0
    }

    checkInvoice(invoiceId, isChecked) {
        let amounts = this.state.invoicePayments.map(pay => {
            if (pay.invoiceId === invoiceId) {
                pay.checked = isChecked
                if (isChecked) {
                    pay.amount = pay.balance
                } else {
                    pay.amount = 0
                }
            }
            return pay
        })
        const totalAmount = this.getTotalAmount(amounts)

        this.setState({
            invoicePayments: amounts,
            amount: totalAmount,
        })
        this.state.invoicePayments = amounts
        this.state.amount = totalAmount
    }

    getInvoiceAmount(invoiceId) {
        const pay = this.state.invoicePayments.filter(pay => pay.invoiceId === invoiceId)[0]
        return pay ? pay.amount : ''
    }

    isInvoiceChecked(invoiceId) {
        const pay = this.state.invoicePayments.filter(pay => pay.invoiceId === invoiceId)[0]
        return pay ? pay.checked : false
    }

    closeModal(event, paymentCompleted) {
        event?.preventDefault()
        this.setState({ isFormDisabled: false });
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            let appliedCreditMemoId = ''
            let paymentType = ''
            if (paymentCompleted) {
                appliedCreditMemoId = this.state.creditMemoId
                paymentType = this.state.paymentType
            }
            this.props.onClose(paymentType, appliedCreditMemoId)
        }
    }

    handleFocus(event) {
        event.target.select()
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    applyPayment(event) {
        event.preventDefault()
        this.submit()
    }

    buildMetaData() {
        const { currency, transactions, documentType } = this.buildTransactionsAndCurrency()
        const identifierList = this.buildIdenitifierList(transactions)
        const documentIdList = this.buildDocumentIds(transactions)
        const amountList = this.buildAmountsList(transactions)
        const locationId = this.buildLocationId()
        const integration = GlobalHelper.getPaymentIntegrationPerLocation(locationId)
        const metadata = {
            documentType: documentType,
            identifier: identifierList,
            documentId: documentIdList,
            contactId: this.state.contactId,
            accountId: AppContext.getAccount().id,
            createdByUserId: AppContext.getUserLoggedIn().id,
            source: PAYMENT_SOURCE.BACKOFFICE,
            locationId: locationId,
            fingerprintId: GlobalHelper.getFingerprintId(),
            amount: amountList,
            currency: AppContext.getCurrency(),
            integrationConfigurationId: integration ? integration.id : "",
            documentCurrency: currency,
            notes: this.state.note,
            transactions: transactions,
        }
        return metadata
    }

    buildDocumentIds(transactions) {
        const documentIds = transactions.map((transaction) => {
            return transaction.invoiceId || transaction.quoteId || transaction.orderId
        }).join(', ');
        return documentIds
    }

    buildAmountsList(transactions) {
        const amounts = transactions.map((transaction) => {
            return transaction.amount
        }).join(', ')
        return amounts
    }

    buildIdenitifierList(transactions) {
        const identifiers = transactions.map((transaction) => {
            return transaction.identifier
        }).join(', ')
        return identifiers
    }

    buildLocationId() {
        return this.state.location?.value || this.state.invoice?.attributes?.locationId || this.state.depositPayableObject?.attributes?.locationId
    }

    getCardsOnFileByIntegrationKey() {
        return this.state.cardsOnFile.filter(cc =>
            cc.attributes.integrationKey === this.state.paymentIntegrationKey &&
            cc.attributes.integrationConfigurationId === this.getPaymentIntegrationId(Features.IntegratedPayment))
    }

    getBankAccountsOnFileByIntegrationKey() {
        return this.state.bankAccountsOnFile.filter(ba => ba.attributes.integrationKey === this.state.paymentIntegrationKey &&
            ba.attributes.integrationConfigurationId === this.getPaymentIntegrationId(AccountFeatures.FeatureIntegratedBankTransfer))
    }

    getPaymentIntegrationId(feature) {
        const integration = AppContext.getIntegrationsByFeature(feature).find(i => i.attributes.locationIds.includes(this.buildLocationId()))
        return integration ? integration.id : AppContext.getIntegrationsByFeature(feature).find(i => i.attributes.locationIds.length == 0)?.id
    }

    setTokens() {
        let defaultBankAccount = this.getBankAccountsOnFileByIntegrationKey().find(b => b.attributes.isDefault)
        let defaultCreditCard = this.getCardsOnFileByIntegrationKey().find(c => c.attributes.isDefault)

        if (!defaultBankAccount && this.getBankAccountsOnFileByIntegrationKey().length > 0) {
            defaultBankAccount = this.getBankAccountsOnFileByIntegrationKey()[0]
        }

        if (!defaultCreditCard && this.getCardsOnFileByIntegrationKey().length > 0) {
            defaultCreditCard = this.getCardsOnFileByIntegrationKey()[0]
        }

        this.setState({
            savedBankAccountToken: defaultBankAccount ? defaultBankAccount.attributes.bankAccount.attributes.bankAccountToken : '',
            savedCardToken: defaultCreditCard ? defaultCreditCard.attributes.card.attributes.cardToken : '',
            savedCardPaymentFlow: defaultCreditCard ? defaultCreditCard.attributes.card.attributes.paymentFlowType : ''
        })
    }

    buildTransactionsAndCurrency() {
        let transactions = []
        let currency = ''
        let documentType = ""
        if (this.state.invoice) {
            transactions.push({
                identifier: this.state.invoice.attributes.identifier,
                invoiceId: this.state.invoice.id,
                amount: this.state.amount,
            })
            documentType = PROPOSAL_TYPE.INVOICE
            currency = this.state.invoice.attributes.currency
        } else if (this.state.depositPayableObject) {
            switch (this.state.depositPayableObject.type) {
                case 'quotes':
                    transactions.push({
                        identifier: this.state.depositPayableObject.attributes.identifier,
                        quoteId: this.state.depositPayableObject.id,
                        amount: this.state.amount,
                    })
                    documentType = PROPOSAL_TYPE.QUOTE
                    break
                case 'orders':
                    transactions.push({
                        identifier: this.state.depositPayableObject.attributes.identifier,
                        orderId: this.state.depositPayableObject.id,
                        amount: this.state.amount,
                    })
                    documentType = PROPOSAL_TYPE.ORDER
                    break
            }
            currency = this.state.depositPayableObject.attributes.currency
        } else {
            transactions = this.state.invoicePayments.filter(pay => pay.amount > 0 && pay.checked).map(pay => {
                return {
                    identifier: pay.identifier,
                    invoiceId: pay.invoiceId,
                    amount: String(pay.amount),
                }
            })
            documentType = PROPOSAL_TYPE.INVOICE
            currency = this.state.customerAccount.attributes.owingBalanceCurrency
        }

        return {
            currency: currency,
            transactions: transactions,
            documentType: documentType
        }
    }

    submit(integrationToken, saveCard, next) {
        const { currency, transactions, _ } = this.buildTransactionsAndCurrency()
        let data = {
            note: this.state.note,
            source: 'back-office',
            paymentType: (!this.state.creditMemoId && !['quote-deposit', 'order-deposit', 'price-list-deposit']
                .includes(this.state.paymentType)) ? this.state.paymentType : 'credit',
            currency: currency,
            transactions: transactions,
            contactId: this.state.contactId,
            creditMemoId: this.state.creditMemoId,
            capturedAt: this.state.capturedAt,
            locationId: this.state.invoice?.attributes?.locationId || this.state.depositPayableObject?.attributes?.locationId,
        }
        let waitForPaymentConfirmation = false
        if (integrationToken && this.state.paymentType === 'credit-card') {
            data.creditCard = {
                savedCardToken: integrationToken.savedCardToken || '',
                singleUseToken: integrationToken.token || '',
                saveCard: integrationToken.saveCard,
                verificationToken: integrationToken.verificationToken || '',
                paymentFlow: 'token',
            }
            if (this.state.invoice && this.state.invoice.attributes.locationId) {
                data.creditCard.locationId = this.state.invoice.attributes.locationId
            } else if (this.buildLocationId()) {
                data.creditCard.locationId = this.buildLocationId()
            }
            if (integrationToken.billingDetails) {
                data.billingDetails = integrationToken.billingDetails
            }
            data.fingerprintId = GlobalHelper.getFingerprintId()
        } else if (this.state.enableIntegratedPayment && this.state.paymentType === 'credit-card') {
            data.creditCard = {
                saveCard,
                savedCardToken: this.state.savedCardToken,
                paymentFlow: this.state.savedCardPaymentFlow || 'payment-intent',
            }
            if (this.state.invoice && this.state.invoice.attributes.locationId) {
                data.creditCard.locationId = this.state.invoice.attributes.locationId
            } else if (this.buildLocationId()) {
                data.creditCard.locationId = this.buildLocationId()
            }
            data.fingerprintId = GlobalHelper.getFingerprintId()
            if (!this.state.savedCardToken && data.creditCard.paymentFlow === 'payment-intent') {
                waitForPaymentConfirmation = true
            }
        } else if (integrationToken && this.state.paymentType === 'bank-transfer') {
            data.bankAccount = {
                savedBankAccountToken: integrationToken.savedBankAccountToken || '',
                fingerprintId: GlobalHelper.getFingerprintId(),
            }
            if (this.state.invoice && this.state.invoice.attributes.locationId) {
                data.bankAccount.locationId = this.state.invoice.attributes.locationId
            } else if (this.buildLocationId()) {
                data.bankAccount.locationId = this.buildLocationId()
            }
        }

        if (this.state.customPaymentTypeId) {
            data.paymentTypeId = this.state.customPaymentTypeId
        }
        this.setState({ isLoading: true })
        AppContext.getApiClient().post('/payment-transactions', data).then(res => {
            this.setState({
                isLoading: false,
                creditCardError: '',
            })

            if (res.error) {
                this.setState({
                    creditCardError: <div className={"col-12 mt-2"}>
                        <small className={"text-danger"}>
                            {res.error.message === 'Authentication required' ? <FormattedMessage
                                id="customers.invoices.list.cards.requires_authentication"
                                defaultMessage="The card you selected requires an authentication. Send an invoice to the customer to let them initiate the credit card payment process or choose another card."
                            /> : res.error.message}
                        </small>
                    </div>
                })
                if (next) {
                    next(res)
                }
                return
            }

            if (res.data.length > 0) {
                const lastPayment = res.data[0].attributes.paymentTransactions[res.data[0].attributes.paymentTransactions.length - 1].attributes.payment
                if (waitForPaymentConfirmation) {
                    this.setState({
                        tempObject: res.data[0],
                        lastPayment,
                    })
                    EventBus.dispatch(EventBus.TopicPaymentTransactionCreated, {
                        payment: lastPayment,
                    })
                    return
                }
            }

            if (next) {
                next(res)
            }
            if (!res.error) {
                this.closeModal(null, true)
            }
        })
    }

    handlePaymentIntentCompleted(paymentIntent) {
        if (!paymentIntent.error && paymentIntent.paymentIntent.status === 'succeeded') {
            this.setState({
                isLoading: true,
                disableSubmitButtonOnSuccess: true,
            }, () => {
                if (this.state.tempObject && this.state.tempObject.attributes.proposalHash && this.state.lastPayment) {
                    AppContext.getApiClient().post(`/proposals/${this.state.tempObject.attributes.proposalHash}/payments/${this.state.lastPayment.id}/confirm`, {}).then(res => {
                        this.closeModal(null, true)
                    })
                } else {
                    setTimeout(this.closeModal(null, true), 2000)
                }
            })
        } else {
            if (!paymentIntent.error && this.state.tempObject && this.state.tempObject.attributes.proposalHash && this.state.lastPayment) {
                AppContext.getApiClient().post(`/proposals/${this.state.tempObject.attributes.proposalHash}/payments/${this.state.lastPayment.id}/cancel`, {}).then(res => {
                    this.setState({
                        loading: false,
                        creditCardError: <div className={"col-12"}>
                            <small className={"text-danger"}>
                                <FormattedMessage
                                    id="customers.invoices.list.cards.new_card_requires_authentication"
                                    defaultMessage="The card you are trying to use requires an authentication. Send an invoice to the customer to let them initiate the credit card payment process or choose another card."
                                />
                            </small>
                        </div>
                    })
                })
            } else {
                if (paymentIntent.error && this.state.tempObject && this.state.tempObject.attributes.proposalHash && this.state.lastPayment) {
                    AppContext.getApiClient().post(`/proposals/${this.state.tempObject.attributes.proposalHash}/payments/${this.state.lastPayment.id}/cancel`, {}).then(res => { })
                }
                this.setState({
                    loading: false,
                    creditCardError: <div className={"col-12"}>
                        <small className={"text-danger"}>
                            {paymentIntent.error.message}
                        </small>
                    </div>
                })
            }
        }
    }

    handleSubmitNewCard(setupIntent, token, saveCard, error, next) {
        if (error) {
            this.setState({
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{error.message}</small>
                </div>
            })
            next()
            return
        }
        this.submit(token, saveCard, res => {
            if (res.error) {
                this.setState({
                    creditCardError: <div className={"col-12"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                })
            }
            next()
        })
    }

    handleSubmitExistingCard(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
        })
        this.submit(null, false, res => {
            this.setState({
                isLoading: false,
            })
            if (res.error) {
                this.setState({
                    creditCardError: <div className={"w-100"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                })
            }
        })
    }

    handleSubmitExistingBankAccount(event) {
        event.preventDefault()
        this.setState({ isLoading: true })
        this.submit({
            savedBankAccountToken: this.state.savedBankAccountToken,
        }, false, res => {
            this.setState({
                isLoading: false
            })
            if (res.error) {
                this.setState({
                    creditCardError: <div className={"w-100"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                })
            }
        })
    }

    changePercent(event) {
        event.preventDefault()
        let amount = parseFloat(event.target.value) * parseFloat(this.state.totalAmount) / 100
        const balance = parseFloat(this.getAmount(this.state.invoice, this.state.depositPayableObject))
        if (amount > balance) {
            amount = balance
        }
        this.setState({
            percent: event.target.value,
            amount: amount ? amount.toFixed(2).toString() : '0',
        })
    }

    isAllChecked() {
        return this.state.invoicePayments.length === this.state.invoicePayments.filter(pay => pay.checked || pay.isBlocked).length
    }

    onLocationSelect(location) {
        const dueInvoices = this.state.dueInvoicesPerLocation[location.value]
        const payments = dueInvoices.map(inv => {
            return {
                invoiceId: inv.id,
                identifier: inv.identifier,
                currency: inv.currency,
                checked: (GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) && inv.importedAt !== null) ? false : true,
                amount: parseFloat(inv.balance),
                balance: parseFloat(inv.balance),
                isBlocked: (GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) && inv.importedAt !== null) ? true : false
            }
        })
        this.setState({
            selectedDueInvoices: dueInvoices,
            location: location,
            invoicePayments: payments,
            amount: this.getTotalAmount(payments),
            savedCardToken: "",
            savedBankAccountToken: "",
        }, () => {
            this.setTokens()
        })
    }

    checkAllInvoices(isChecked) {
        let amounts = this.state.invoicePayments.map(pay => {
            pay.checked = isChecked && !pay.isBlocked
            if (isChecked && !pay.isBlocked) {
                pay.amount = pay.balance
            } else {
                pay.amount = 0
            }
            return pay
        })
        const totalAmount = this.getTotalAmount(amounts)

        this.setState({
            invoicePayments: amounts,
            amount: totalAmount,
        })
        this.state.invoicePayments = amounts
        this.state.amount = totalAmount
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="customers.invoices.list.headers.id_label"
                defaultMessage="ID"
            />,
        ]
        if (this.state.contactType === 'organizations') {
            headers.push(<FormattedMessage
                id="customers.invoices.list.headers.employee_label"
                defaultMessage="Employee"
            />)
        }
        headers = headers.concat([
            <FormattedMessage
                id="customers.invoices.list.headers.balance_label"
                defaultMessage="Balance"
            />,
            <FormattedMessage
                id="customers.invoices.list.headers.pay_amount_label"
                defaultMessage="Pay amount"
            />,
            <Checkbox checked={this.isAllChecked()} onChange={this.checkAllInvoices} />,
        ])
        return headers
    }

    row(invoice) {
        let rows = [
            <span>
                {invoice.identifier}
                <small className="ml-2">{invoice.poNumber}</small>
            </span>,
        ]
        if (this.state.contactType === 'organizations') {
            rows.push(invoice.contact ? invoice.contact.name : '-')
        }
        const checked = this.isInvoiceChecked(invoice.id)
        rows = rows.concat([
            <FormattedNumber
                style="currency"
                currency={invoice.currency}
                value={invoice.balance}
            />,
            <MoneyInputForm
                id={'amount_' + invoice.id}
                currency={invoice.currency}
                max={invoice.balance}
                value={checked ? this.getInvoiceAmount(invoice.id) : 0}
                onChange={val => { this.setInvoiceAmount(invoice.id, val) }}
                inputClassName={'text-right'}
                debounced={true}
                debounceTimeout={1000}
                disabled={!checked}
            />,
            <CheckboxWrapper
                message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                    <FormattedMessage
                        id="listing.search.invoice_document_limit"
                        defaultMessage="Documents limit exceeded."
                    /> : ''}
                onClick={isChecked => { this.checkInvoice(invoice.id, isChecked) }}
                onClickProtected={this.closeModal}
                checked={checked}
                className={""}
                redirectToAccount={true}
                index={rows.length}
                protectedClassName={"btn btn-sm btn-success mr-2 mb-2"}
                premium={false}
                protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) || invoice.importedAt === null}>
            </CheckboxWrapper>
            ,
        ])
        return {
            className: checked ? '' : 'bg-light',
            data: rows,
        }
    }

    showPaymentForm() {
        return this.state.enableIntegratedPayment && this.state.paymentType === 'credit-card'
    }

    isSupportedCurrency() {
        const accountCurrency = AppContext.getCurrency()
        const { currency: documentCurrency, _transactions, _documentType } = this.buildTransactionsAndCurrency()
        return accountCurrency == CURRENCY.USD && documentCurrency == CURRENCY.USD
    }

    showCardsOnFile() {
        const hasCardsOnFile = this.getCardsOnFileByIntegrationKey().length > 0
        if (this.state.paymentIntegrationKey != INTEGRATION_KEY.RAINFOREST || this.isSupportedCurrency()) {
            return hasCardsOnFile
        }
        return false
    }

    showTabAndContent() {
        return this.state.paymentIntegrationKey != INTEGRATION_KEY.RAINFOREST ? true : this.isSupportedCurrency()
    }

    showBankTransferPaymentForm() {
        const isBankTransferEnabled = this.state.enableIntegratedPaymentBankTransfer && this.state.paymentType === PAYMENT_TYPE.BANK_TRANSFER && this.state.hasIntegratedPaymentBankTransfer
        if (this.state.paymentIntegrationKey === INTEGRATION_KEY.RAINFOREST) {
            return isBankTransferEnabled
        }
        return isBankTransferEnabled && this.state.bankAccountsOnFile.length > 0
    }

    canEditDepositAmountToUse() {
        switch (this.state.paymentType) {
            case 'quote-deposit': return this.state.depositPayableObject.type !== 'quotes'
            case 'order-deposit': return this.state.depositPayableObject.type !== 'orders'
            default: return true
        }
    }

    renderDepositCreditMemoByDepositLinkType(depositPaymentType, depositLinkType, balance) {
        return depositPaymentType === this.state.paymentType ?
            <div className="form-group row mb-1">
                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="paymentType">
                    {this.props.intl.formatMessage(messages[depositLinkType + '_deposit_label'])}
                </label>
                <div className="col-12 col-md-9 mb-2">
                    <DepositCreditMemoSelect
                        invoice={this.state.invoice}
                        depositPayableObject={this.state.depositPayableObject}
                        object={this.state.invoice || this.state.depositPayableObject}
                        contactId={this.state.contactId}
                        mustCoverFullAmount={this.state.invoicePayments.length > 0}
                        initialAmount={this.state.amount}
                        onChange={(creditMemoId, creditMemoAmount) => {
                            this.setState({
                                creditMemoId,
                                amount: !(this.state.invoicePayments.length > 0) ? creditMemoAmount : this.state.amount,
                                creditMemoAmount,
                            })
                        }}
                        depositLinkType={depositLinkType}
                        depositTransactions={this.state.depositTransactions}
                        loadNextDepositLinkType={
                            this.state.hasCreditMemoReference ? () => {
                                if (this.state.paymentType === 'quote-deposit') {
                                    this.setState({
                                        paymentType: 'order-deposit',
                                    })
                                }
                            } : () => { }
                        }
                        orderReferenceId={this.state.invoice ? this.state.invoice.attributes.orderReferenceId : ''}
                    />
                    {this.state.depositPayableObject && this.state.depositPayableObject.type === depositLinkType &&
                        [parseFloat(this.state.amount) <= parseFloat(balance) ?
                            <small className="mt-2">
                                <span className="text-danger"><Icon value={'exclamation'} /></span>
                                <span className="text-warning">
                                    <FormattedMessage
                                        id="invoice.receive_payment.deposit_warning"
                                        defaultMessage="By selecting a deposit as a payment, the existing deposit will be transferred from the original document which received the deposit to the current document."
                                    />
                                </span>
                            </small> : ''
                            , parseFloat(this.state.amount) > parseFloat(balance) ?
                            <small className="mt-2">
                                <span className="text-danger"><Icon value={'exclamation'} /></span>
                                <span className="text-warning">
                                    <FormattedMessage
                                        id="invoice.receive_payment.deposit_warning2"
                                        defaultMessage="You cannot transfer a deposit whose amount is greater than the current document's deposit balance."
                                    />
                                </span>
                            </small> : ''
                        ]
                    }
                </div>
            </div> : ''
    }

    isTerminalPaymentEnabled() {
        return this.state.terminals.length > 0 && INTEGRATIONS_TERMINAL_PAYMENT_SUPPORT.includes(this.state.paymentIntegrationKey) && this.state.currentPaymentAccount
    }

    render() {

        let currency = this.state.customerAccountId ? this.state.customerAccount.attributes.owingBalanceCurrency :
            this.getCurrency(this.state.invoice || this.state.depositPayableObject)

        const amount = parseFloat(this.state.amount || 0).toFixed(2)
        let balance = parseFloat(this.state.customerAccountId ? this.state.customerAccount.attributes.owingBalance :
            this.getAmount(this.state.invoice, this.state.depositPayableObject)).toFixed(2)
        if (this.state.customerAccountId) {
            balance = this.state.invoicePayments.reduce(function (accumulator, pay) {
                return accumulator + pay.balance;
            }, 0).toFixed(2)
        }
        let newBalance = (balance - amount).toFixed(2)
        if (newBalance == 0) {
            newBalance = Math.abs(newBalance)
        }
        const notEnoughCreditLeft = this.state.paymentType === 'credit' && amount > parseFloat(this.state.creditBalance)
        const submitDisabled = newBalance < 0 || amount == 0 || notEnoughCreditLeft ||
            (this.state.creditMemoAmount && parseFloat(this.state.amount) > parseFloat(this.state.creditMemoAmount)) ||
            (this.state.paymentType == "credit" && !(parseFloat(this.state.creditMemoAmount) > 0)) ||
            (['quote-deposit', 'order-deposit', 'price-list-deposit'].includes(this.state.paymentType) && !this.state.creditMemoId)
        const countryCode = GlobalHelper.getCountryCodeFromCurrency(currency)
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="emailModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="emailModalTitle">
                            <Icon value={'dollar-sign'} className={'mr-1'} />
                            {this.state.invoice || this.state.depositPayableObject ? <FormattedMessage
                                id="invoice.receive_payment.title"
                                defaultMessage="Receive payment for {identifier}"
                                values={{
                                    identifier: this.getIdentifier(this.state.invoice || this.state.depositPayableObject),
                                }}
                            /> : <FormattedMessage
                                id="invoice.receive_payment.multi_invoices_title"
                                defaultMessage="Receive payment for invoices"
                            />}
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">

                            <div className="form-group row mb-3 py-2">
                                <label className="col-12 col-md-3 col-form-label custom-form-label" htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.receive_payment.payment_date_label"
                                        defaultMessage="Payment date"
                                    />
                                </label>
                                <div className="col-12 col-md-9 d-flex align-items-center customDatePickerWidth">
                                    <DatePicker
                                        selected={this.state.capturedAt}
                                        onChange={date => {
                                            this.setState({
                                                capturedAt: date,
                                            })
                                        }}
                                        showTimeSelect
                                        timeFormat="p"
                                        dateFormat="MMMM dd, yyyy, p"
                                        locale={this.state.locale}
                                        readOnly={this.state.isFormDisabled}
                                    />
                                </div>
                            </div>

                            {this.state.customerAccountId ?
                                <>
                                    {!GlobalHelper.areAllEnabledLocationsAssignedToOneIntegration() &&
                                        <>
                                            {this.state.locations.length == 0 && !this.state.loadingLocations ?
                                                <div className="form-group row mb-3">
                                                    <div className="col-12 col-md-12">
                                                        <FormattedMessage
                                                            id="invoice.receive_payment.no_locations_due_invoices"
                                                            defaultMessage="Assign locations to your due invoices." />
                                                    </div>
                                                </div> : <>
                                                    <div className="form-group row mb-3">
                                                        <label className="col-12 col-md-3 col-form-label custom-form-label" htmlFor="amount">
                                                            <FormattedMessage
                                                                id="invoice.listing.headers.location_label"
                                                                defaultMessage="Location"
                                                            />
                                                        </label>
                                                        <div className="col-12 col-md-9">
                                                            <LocationSelect
                                                                selectedLocationIds={this.state.location}
                                                                isLoadingLocations={this.state.loadingLocations}
                                                                locations={this.state.locations.map(loc => new Location(loc))}
                                                                multi={false}
                                                                onSelect={(location) => this.onLocationSelect(location)}
                                                            />
                                                        </div>
                                                    </div>
                                                </>}
                                        </>
                                    }
                                    <StandardList
                                        smallLine={true}
                                        className="row pt-0"
                                        headers={this.headers()}
                                        rows={this.state.selectedDueInvoices.map(inv => this.row(inv))}
                                    />
                                </> : <div className="form-group row mb-3 bg-light py-2">
                                    <label className="col-12 col-md-3  col-form-label custom-form-label" htmlFor="amount">
                                        <FormattedMessage
                                            id="invoice.receive_payment.calculator_label"
                                            defaultMessage="Calculator"
                                        />
                                    </label>
                                    <div className="col-12 col-md-6 d-flex align-items-center px-0">
                                        <div className={'text-right w-100'}>
                                            <FormattedNumber
                                                value={this.state.totalAmount}
                                                currency={this.state.activeCurrency}
                                                style={'currency'}
                                            />
                                            &nbsp;&nbsp;x&nbsp;&nbsp;
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <DebounceInput
                                                type="number"
                                                max={'100'}
                                                min={'0'}
                                                className="form-control"
                                                placeholder="i.e: 30"
                                                value={this.state.percent}
                                                onChange={this.changePercent}
                                                debounceTimeout={500}
                                                disabled={this.state.isFormDisabled || ((this.state.depositPayableObject) && ['quote-deposit', 'order-deposit', 'price-list-deposit'].includes(this.state.paymentType))}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            <div className="form-group row mb-1">
                                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.receive_payment.amount_label"
                                        defaultMessage="Amount"
                                    />
                                </label>
                                <div className="col-12 col-md-9">
                                    <MoneyInputForm
                                        className={'mb-2'}
                                        currency={currency}
                                        value={this.state.amount}
                                        onChange={val => { this.setState({ amount: val, percent: '' }) }}
                                        inputClassName={'text-right'}
                                        debounced={true}
                                        disabled={
                                            this.state.isFormDisabled ||
                                            (this.state.depositPayableObject && !this.canEditDepositAmountToUse()) ||
                                            this.state.customerAccountId
                                        }
                                    />
                                </div>
                            </div>

                            <div className="form-group row mb-1">
                                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="paymentType">
                                    <FormattedMessage
                                        id="invoice.receive_payment.payment_type_label"
                                        defaultMessage="Payment type"
                                    />
                                </label>
                                <div className="col-12 col-md-9 mb-2">
                                    <PaymentTypeSelect
                                        paymentType={this.state.customPaymentTypeId ? this.state.customPaymentTypeId : this.state.paymentType}
                                        creditBalance={this.state.creditBalance - this.state.creditBalanceFromDeposit}
                                        depositBalance={this.state.creditBalanceFromDeposit}
                                        creditCurrency={this.state.creditCurrency}
                                        onChange={(paymentType, customPaymentTypeId) => {
                                            if ((this.state.invoice || this.state.depositPayableObject) &&
                                                ['credit', 'quote-deposit', 'order-deposit', 'price-list-deposit'].includes(this.state.paymentType) &&
                                                !['credit', 'quote-deposit', 'order-deposit', 'price-list-deposit'].includes(paymentType)) {
                                                this.setState({
                                                    amount: this.getAmount(this.props.invoice, this.props.depositPayableObject),
                                                })
                                            }

                                            this.setState({
                                                paymentType,
                                                customPaymentTypeId,
                                                creditMemoAmount: 0,
                                                creditMemoId: '',
                                            })
                                        }}
                                        hideDepositTotalAmountLeft={this.state.depositPayableObject ? true : false}
                                        orderReferenceId={this.state.invoice ? this.state.invoice.attributes.orderReferenceId : ''}
                                        disabled={this.state.isFormDisabled}
                                    />
                                </div>
                            </div>
                            {this.state.paymentType == "credit" &&
                                <div className="form-group row mb-1">
                                    <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="paymentType">
                                        <FormattedMessage
                                            id="invoice.receive_payment.credit_memo_label"
                                            defaultMessage="Credit memo"
                                        />
                                    </label>
                                    <div className="col-12 col-md-9 mb-2">
                                        <DepositCreditMemoSelect
                                            invoice={this.state.invoice}
                                            depositPayableObject={this.state.depositPayableObject}
                                            object={this.state.invoice || this.state.depositPayableObject}
                                            contactId={this.state.contactId}
                                            mustCoverFullAmount={this.state.invoicePayments.length > 0}
                                            initialAmount={this.state.amount}
                                            onChange={(creditMemoId, creditMemoAmount) => {
                                                this.setState({
                                                    creditMemoId,
                                                    amount: !(this.state.invoicePayments.length > 0) ? creditMemoAmount : this.state.amount,
                                                    creditMemoAmount,
                                                })
                                            }}
                                            disabled={this.state.isFormDisabled}
                                        />
                                    </div>
                                </div>
                            }
                            {this.renderDepositCreditMemoByDepositLinkType('quote-deposit', 'quotes', balance)}
                            {this.renderDepositCreditMemoByDepositLinkType('order-deposit', 'orders', balance)}
                            {this.renderDepositCreditMemoByDepositLinkType('price-list-deposit', 'price-lists', balance)}
                            <div className="form-group row mb-0">
                                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2">
                                    <FormattedMessage
                                        id="invoice.receive_payment.note_label"
                                        defaultMessage="Note"
                                    />
                                </label>
                                <div className="col-12 col-md-9">
                                    <textarea
                                        name="note"
                                        value={this.state.note}
                                        onChange={this.handleFormChange}
                                        id="note"
                                        rows="3"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages["note_placeholder"])}
                                        disabled={this.state.isFormDisabled}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mt-2 mb-0 justify-content-end">
                                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.receive_payment.balance_label"
                                        defaultMessage="Current balance"
                                    />
                                </label>
                                <div className="col-1">
                                </div>
                                <div className="col-2">
                                    <div className="input-group mb-0 py-1 text-right justify-content-end">
                                        <strong>
                                            <FormattedNumber
                                                value={balance}
                                                currency={currency}
                                                style={'currency'}
                                            />
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row mb-0 justify-content-end">
                                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.receive_payment.payment_label"
                                        defaultMessage="Payment"
                                    />
                                </label>
                                <div className="col-1 d-flex align-items-center justify-content-end">
                                    <Icon value={'minus'} />
                                </div>
                                <div className="col-2">
                                    <div className="input-group mb-0 py-1 text-right justify-content-end">
                                        <strong>
                                            <FormattedNumber
                                                value={amount}
                                                currency={currency}
                                                style={'currency'}
                                            />
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row mb-1 justify-content-end">
                                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.receive_payment.new_balance_label"
                                        defaultMessage="New balance"
                                    />
                                </label>
                                <div className="col-1 d-flex align-items-center justify-content-end">
                                    <Icon value={'equals'} />
                                </div>
                                <div className="col-2">
                                    <div className="input-group mb-0 py-1 justify-content-end">
                                        <strong>
                                            <FormattedNumber
                                                value={newBalance}
                                                currency={currency}
                                                style={'currency'}
                                            />
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            {this.state.hasIntegratedPayment && this.state.paymentType === 'credit-card' && (this.state.paymentIntegrationKey !== INTEGRATION_KEY.SQUARE || !!this.state.invoice) ?
                                <div className="form-group row mb-1 justify-content-end">
                                    <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                                        <FormattedMessage
                                            id="invoice.receive_payment.enable_integrated_payment_label"
                                            defaultMessage="Process payment"
                                        />
                                    </label>
                                    <div className="col-3 d-flex align-items-center justify-content-end">
                                        <Toggle
                                            defaultChecked={this.state.enableIntegratedPayment}
                                            icons={false}
                                            onChange={() => {
                                                this.setState({ enableIntegratedPayment: !this.state.enableIntegratedPayment })
                                            }}
                                            disabled={this.state.isFormDisabled}
                                        />
                                    </div>
                                </div> : ''}
                            {this.state.hasIntegratedPaymentBankTransfer && this.state.paymentType === 'bank-transfer' && this.state.bankAccountsOnFile.length > 0 ? <div className="form-group row mb-1 justify-content-end">
                                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.receive_payment.enable_integrated_payment_label"
                                        defaultMessage="Process payment"
                                    />
                                </label>
                                <div className="col-3 d-flex align-items-center justify-content-end">
                                    <Toggle
                                        defaultChecked={this.state.enableIntegratedPaymentBankTransfer}
                                        icons={false}
                                        onChange={() => {
                                            this.setState({ enableIntegratedPaymentBankTransfer: !this.state.enableIntegratedPaymentBankTransfer })
                                        }}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                            </div> : ''}
                            {/* BANK ACCOUNTS PAYMENT */}
                            {this.showBankTransferPaymentForm() ?
                                <div className="form-group row mb-1 justify-content-end">
                                    {/* BANK ACCOUNTS PAYMENT -> TABS */}
                                    <nav className={"col-12 mt-2 px-0"}>
                                        <div className="nav nav-tabs justify-content-end" id="nav-tab" role="tablist">
                                            {this.getBankAccountsOnFileByIntegrationKey().length > 0 && this.showTabAndContent() && <a className="nav-item nav-link active"
                                                id="nav-bank-accounts-on-file-tab"
                                                data-toggle="tab"
                                                href="#nav-bank-accounts-on-file"
                                                role="tab"
                                                aria-controls="nav-bank-accounts-on-file-tab"
                                                aria-selected="true">
                                                <FormattedMessage
                                                    id="invoice.receive_payment.bank_accounts_on_file_tab"
                                                    defaultMessage="Bank accounts on file"
                                                />
                                            </a>}
                                            <a className={"nav-item nav-link " + ((this.getBankAccountsOnFileByIntegrationKey().length === 0 || !this.showTabAndContent()) ? "active" : "")}
                                                id="nav-bank-accounts-tab"
                                                data-toggle="tab"
                                                href="#nav-bank-accounts"
                                                role="tab"
                                                aria-controls="nav-bank-accounts-tab"
                                                aria-selected="false"
                                                onClick={e => {
                                                    e.preventDefault()
                                                    this.setState({
                                                        creditCardError: "",
                                                        savedCardToken: "",
                                                        savedCardPaymentFlow: "payment-intent",
                                                    })
                                                }}>
                                                <FormattedMessage
                                                    id="invoice.receive_payment.bank_account_tab"
                                                    defaultMessage="Manual Entry"
                                                />
                                            </a>
                                        </div>
                                    </nav>
                                    <div className="col-12 tab-content pt-3" id="nav-tabContent">
                                        {/* BANK ACCOUNTS ON FILE */}
                                        {this.getBankAccountsOnFileByIntegrationKey().length > 0 && this.showTabAndContent() && <div className="row tab-pane fade show active justify-content-end"
                                            id="nav-bank-accounts-on-file"
                                            role="tabpanel"
                                            aria-labelledby="nav-bank-accounts-on-file-tab"
                                        >
                                            <div className={'col-12 col-lg-6 mb-0 py-2 bg-light ignore-active border ml-auto'}>
                                                <TestModeAlert className="mt-2" />
                                                {this.getBankAccountsOnFileByIntegrationKey().map(c => {
                                                    return <div className={'w-100 d-flex py-2'} key={c.id}>
                                                        <div className={'mr-2'}>
                                                            <div className="custom-control custom-radio">
                                                                <input
                                                                    type="radio"
                                                                    id={c.id}
                                                                    name="bankAccountOnFile"
                                                                    value={c.attributes.bankAccount.attributes.bankAccountToken}
                                                                    checked={c.attributes.bankAccount.attributes.bankAccountToken == this.state.savedBankAccountToken}
                                                                    className="custom-control-input"
                                                                    onChange={e => {
                                                                        this.setState({
                                                                            savedBankAccountToken: e.target.value,
                                                                            savedCardToken: '',
                                                                        })
                                                                    }}
                                                                    disabled={this.state.isFormDisabled}
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor={c.id}
                                                                >
                                                                    <span className="mr-2"><BankAccountLabel value={c.attributes.bankAccount} /></span>
                                                                    {c.attributes.bankAccount.attributes.accountHolderName}
                                                                    {c.attributes.isDefault ? <span className="badge badge-primary ml-2 text-white-badge">
                                                                        <FormattedMessage
                                                                            id="cards_on_file.default_label"
                                                                            defaultMessage="Default"
                                                                        />
                                                                    </span> : ''}
                                                                    {c.attributes.isTestPaymentMethod ? <TestPaymentMethodBadge paymentMethodType={PAYMENT_METHOD.BANK_ACCOUNT} /> : ''}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                                <div className={'w-100 text-right mt-3'}>
                                                    <ActionButton
                                                        disabled={this.state.isFormDisabled || submitDisabled || this.state.savedBankAccountToken == ''}
                                                        className={'btn btn-primary'}
                                                        isLoading={this.state.isLoading}
                                                        onClick={this.handleSubmitExistingBankAccount}
                                                    >
                                                        <FormattedMessage
                                                            id="invoice.receive_payment.apply_payment_btn"
                                                            defaultMessage="Apply payment"
                                                        />
                                                    </ActionButton>
                                                    {this.state.creditCardError}
                                                </div>
                                            </div>
                                        </div>}
                                        {/* BANK ACCOUNT PAYMENT FORM */}
                                        <div className={"row tab-pane fade justify-content-end " + ((this.getBankAccountsOnFileByIntegrationKey().length === 0 || !this.showTabAndContent()) ? "show active" : '')}
                                            id="nav-bank-accounts"
                                            role="tabpanel"
                                            aria-labelledby="nav-bank-accounts-tab"
                                        >
                                            <div className={'col-12 col-lg-6 mb-0 py-2 bg-light border ignore-active ml-auto'}>
                                                <TestModeAlert className="mt-2" />
                                                <OnlinePayment
                                                    countryCode={countryCode}
                                                    submitButton={<FormattedMessage
                                                        id="invoice.receive_payment.apply_payment_btn"
                                                        defaultMessage="Apply payment"
                                                    />}
                                                    submitDisabled={submitDisabled || this.state.disableSubmitButtonOnSuccess}
                                                    amount={amount}
                                                    currency={currency}
                                                    paymentType={'bank-transfer'}
                                                    onPaymentIntentCompleted={this.handlePaymentIntentCompleted}
                                                    contactId={this.state.contactId}
                                                    ignoreAuthentication={true}
                                                    buildMetaData={this.buildMetaData}
                                                    onClose={() => this.closeModal(null, true)}
                                                    proposalHash={this.state.invoice?.attributes?.proposalHash || this.state.depositPayableObject?.attributes?.proposalHash}
                                                    locationId={this.buildLocationId()}
                                                />
                                                {this.state.creditCardError}
                                            </div>
                                        </div>
                                    </div>
                                </div> : ''}
                            {/* CREDIT CARD PAYMENT */}
                            {this.showPaymentForm() ? <div className="form-group row mb-1 justify-content-end">
                                {/* CREDIT CARD -> TABS */}
                                <nav className={'col-12 mt-2 px-0'}>
                                    <div className="nav nav-tabs justify-content-end" id="nav-tab" role="tablist">
                                        {this.showCardsOnFile() ? <a className="nav-item nav-link active"
                                            id="av-cards-on-file-tab"
                                            data-toggle="tab"
                                            href="#nav-cards-on-file"
                                            role="tab"
                                            aria-controls="nav-cards-on-file"
                                            aria-selected="true"
                                            onClick={e => {
                                                e.preventDefault()
                                                this.setState({
                                                    creditCardError: '',
                                                    savedCardToken: '',
                                                })
                                            }}>
                                            <FormattedMessage
                                                id="invoice.receive_payment.cards_on_file_tab"
                                                defaultMessage="Cards on file"
                                            />
                                        </a> : ''}
                                        <a className={"nav-item nav-link " + (!this.showCardsOnFile() ? "active" : '')}
                                            id="nav-credit-card-tab" data-toggle="tab"
                                            href="#nav-credit-card" role="tab" aria-controls="nav-credit-card"
                                            aria-selected="false"
                                            onClick={e => {
                                                e.preventDefault()
                                                this.setState({
                                                    creditCardError: '',
                                                    savedCardToken: '',
                                                    savedCardPaymentFlow: 'payment-intent',
                                                })
                                            }}>
                                            <FormattedMessage
                                                id="invoice.receive_payment.credit_card_tab"
                                                defaultMessage="Credit card"
                                            />
                                        </a>
                                        {this.isTerminalPaymentEnabled() && this.showTabAndContent() && (
                                            <a
                                                className={"nav-item nav-link"}
                                                id="nav-terminals-tab" data-toggle="tab"
                                                href="#nav-terminals" role="tab" aria-controls="nav-terminals"
                                                aria-selected="false"
                                                onClick={e => {
                                                    e.preventDefault()
                                                    this.setState({
                                                        creditCardError: '',
                                                        savedCardToken: '',
                                                    })
                                                }}>
                                                <FormattedMessage
                                                    id="invoice.receive_payment.terminal_tab"
                                                    defaultMessage="Terminal"
                                                />
                                            </a>
                                        )}
                                    </div>
                                </nav>
                                <div className="col-12 tab-content pt-3" id="nav-tabContent">
                                    {/* CREDIT CARDS ON FILE */}
                                    {this.showCardsOnFile() ? <div className="row tab-pane fade show active justify-content-end"
                                        id="nav-cards-on-file"
                                        role="tabpanel"
                                        aria-labelledby="nav-cards-on-file-tab"
                                    >
                                        <div className={'col-12 col-lg-6 mb-0 py-2 bg-light border ignore-active ml-auto'}>
                                            <TestModeAlert className="mt-2" />
                                            {this.getCardsOnFileByIntegrationKey().map(c => {
                                                return <div className={'w-100 d-flex py-2'} key={c.id}>
                                                    <div className={'mr-2'}>
                                                        <div className="custom-control custom-radio">
                                                            <input
                                                                type="radio"
                                                                id={c.id}
                                                                name="cardOnFile"
                                                                value={c.attributes.card.attributes.cardToken}
                                                                checked={c.attributes.card.attributes.cardToken == this.state.savedCardToken}
                                                                className="custom-control-input"
                                                                onChange={e => {
                                                                    this.setState({
                                                                        savedCardPaymentFlow: c.attributes.card.attributes.paymentFlowType,
                                                                        savedCardToken: e.target.value,
                                                                    })
                                                                }}
                                                                disabled={this.state.isFormDisabled}
                                                            />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor={c.id}
                                                            >
                                                                <CreditCardLabel value={c.attributes.card} />
                                                                <span className={'mx-2'}>
                                                                    {c.attributes.card.attributes.expirationMonth + '/' + c.attributes.card.attributes.expirationYear}
                                                                </span>
                                                                {c.attributes.card.attributes.cardHolderName}
                                                                {c.attributes.isDefault ? <span className="badge badge-primary ml-2 text-white-badge">
                                                                    <FormattedMessage
                                                                        id="cards_on_file.default_label"
                                                                        defaultMessage="Default"
                                                                    />
                                                                </span> : ''}
                                                                {c.attributes.isTestPaymentMethod ? <TestPaymentMethodBadge paymentMethodType={PAYMENT_METHOD.CREDIT_CARD} /> : ''}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            })}
                                            <div className={'w-100 text-right mt-3'}>
                                                <ActionButton
                                                    disabled={this.state.isFormDisabled || submitDisabled || this.state.savedCardToken == ''}
                                                    className={'btn btn-primary'}
                                                    isLoading={this.state.isLoading}
                                                    onClick={this.handleSubmitExistingCard}
                                                >
                                                    <FormattedMessage
                                                        id="invoice.receive_payment.apply_payment_btn"
                                                        defaultMessage="Apply payment"
                                                    />
                                                </ActionButton>
                                                {this.state.creditCardError}
                                            </div>
                                        </div>
                                    </div> : ''}
                                    {/* CREDIT CARD PAYMENT FORM */}
                                    <div className={"row tab-pane fade justify-content-end " + (!this.showCardsOnFile() ? "show active" : '')}
                                        id="nav-credit-card"
                                        role="tabpanel"
                                        aria-labelledby="nav-credit-card-tab"
                                    >
                                        <div className={'col-12 col-lg-6 mb-0 py-2 bg-light border ignore-active ml-auto pl-4'}>
                                            <TestModeAlert className="mt-2" />
                                            <OnlinePayment
                                                countryCode={countryCode}
                                                onSubmit={this.handleSubmitNewCard}
                                                submitButton={<FormattedMessage
                                                    id="invoice.receive_payment.apply_payment_btn"
                                                    defaultMessage="Apply payment"
                                                />}
                                                submitDisabled={this.state.isFormDisabled || submitDisabled || this.state.disableSubmitButtonOnSuccess}
                                                amount={amount}
                                                currency={currency}
                                                paymentType={'credit-card'}
                                                onPaymentIntentCompleted={this.handlePaymentIntentCompleted}
                                                contactId={this.state.contactId}
                                                ignoreAuthentication={true}
                                                buildMetaData={this.buildMetaData}
                                                onClose={() => this.closeModal(null, true)}
                                                proposalHash={this.state.invoice?.attributes?.proposalHash || this.state.depositPayableObject?.attributes?.proposalHash}
                                                locationId={this.buildLocationId()} />
                                            {this.state.creditCardError}
                                        </div>
                                    </div>
                                    {/* TERMINAL PAYMENT */}
                                    {this.isTerminalPaymentEnabled() && (
                                        <div
                                            className={"row tab-pane fade justify-content-end"}
                                            id="nav-terminals"
                                            role="tabpanel"
                                            aria-labelledby="nav-terminals-tab"
                                        >
                                            <div className={'col-12 col-lg-7 mb-0 py-2 bg-light border ignore-active ml-auto'}>
                                                <TestModeAlert className="mt-2" />
                                                <TerminalPayment
                                                    integrationKey={this.state.paymentIntegrationKey}
                                                    paymentAccount={this.state.currentPaymentAccount} //TODO: Once we handle multiple payment accounts, define way to select the desired payment account.
                                                    terminals={this.state.terminals}
                                                    amount={amount}
                                                    currency={currency}
                                                    disabled={this.state.isFormDisabled}
                                                    proposalHash={this.state.invoice?.attributes?.proposalHash || this.state.depositPayableObject?.attributes?.proposalHash}
                                                    contactId={this.state.contactId}
                                                    buildMetaData={this.buildMetaData}
                                                    onPresent={() => this.setState({ isFormDisabled: true })}
                                                    onCancel={() => this.setState({ isFormDisabled: false })}
                                                    onSuccess={() => {
                                                        this.setState({ paymentType: 'credit-card' })
                                                        this.closeModal(null, true)
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div> : ''}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                            <FormattedMessage
                                id="invoice.receive_payment.close_btn"
                                defaultMessage="Close"
                            />
                        </button>
                        {!this.showPaymentForm() && !this.showBankTransferPaymentForm() ? <ActionButton
                            type="button"
                            className="btn btn-primary"
                            isLoading={this.state.isLoading}
                            onClick={this.applyPayment}
                            disabled={submitDisabled}
                        >
                            <FormattedMessage
                                id="invoice.receive_payment.apply_payment_btn"
                                defaultMessage="Apply payment"
                            />
                        </ActionButton> : ''}
                    </div>
                </div>
            </div>
        </div >
    }
}

export default injectIntl(ReceivePaymentModal)



// WEBPACK FOOTER //
// ./src/invoice/receivepaymentmodal.component.jsx